import { render, staticRenderFns } from "./ListadoDocumentos.vue?vue&type=template&id=6e649ef8&scoped=true&"
import script from "./ListadoDocumentos.vue?vue&type=script&lang=js&"
export * from "./ListadoDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e649ef8",
  null
  
)

export default component.exports